import { Popover } from "antd";

const SubLocation = ({ value }) => {
  return value ? (
    <Popover
      placement="right"
      content={
        <span className="text-grayMuted text-xs font-medium">
          {value}
        </span>
      }
      overlayClassName="event-shift-popover"
    >
      <p className="text-grayBlack text-xs font-medium w-fit">{value}</p>
    </Popover>
  ) : (
    <p className="text-grayBlack text-xs font-medium w-fit">N/A</p>
  );
};

export default SubLocation;
